import { useState } from 'react';
import { Box, Button } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import ControlFeedbackItem from './index';
import { useControlFeedback } from './ControlFeedbackContext';

export default function ControlFeedbackContainer() {
  const { feedbackItems, removeFeedback } = useControlFeedback();

  const [expanded, setExpanded] = useState(false);

  const visibleItems = expanded || feedbackItems.length <= 1 ? feedbackItems : [feedbackItems[feedbackItems.length - 1]];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 80,
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        zIndex: 9999,
        pointerEvents: 'none'
      }}>
      {feedbackItems.length > 1 && (
        <Button size="small" variant="contained" startIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />} onClick={() => setExpanded((prev) => !prev)} sx={{ pointerEvents: 'auto' }}>
          {expanded ? 'Collapse' : `${feedbackItems.length - 1} more`}
        </Button>
      )}

      {visibleItems.map((item, index) => {
        const isNewest = index === visibleItems.length - 1;
        const hidden = !expanded && !isNewest;

        return (
          <Box
            key={item.id}
            sx={{
              pointerEvents: 'auto',
              display: hidden ? 'none' : 'block'
            }}>
            <ControlFeedbackItem data={item.data} autoCloseMs={item.autoCloseMs} onClose={() => removeFeedback(item.id)} />
          </Box>
        );
      })}
    </Box>
  );
}
